export default "__VITE_ASSET__f34e9a46__"